import {
  ConfiguratorBreakpoint,
  ConfiguratorContextEngagementPackageLevelDetails,
  ConfiguratorEngagementPackageLevel,
  ConfiguratorStep,
  ConfiguratorThemeCategory,
} from './types';

export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
};

export const CONFIGURATOR_STEPS: ConfiguratorStep[] = [
  {
    id: 'design',
    name: {
      en: 'Design',
    },
    icon: 'bi-brush',
  },
  {
    id: 'engagement',
    name: {
      en: 'Engagement',
    },
    icon: 'bi-phone',
  },
  {
    id: 'traffic',
    name: {
      en: 'Traffic',
    },
    icon: 'bi-people',
  },
  {
    id: 'live',
    name: {
      en: 'Go Live!',
    },
    icon: 'bi-clipboard-check',
  },
];

export const CONFIGURATOR_STEPS_WITH_CASINO_NAME: string[] = [CONFIGURATOR_STEPS[0].id];

export const CONFIGURATOR_STEPS_WITH_PREVIEW: string[] = [CONFIGURATOR_STEPS[0].id, CONFIGURATOR_STEPS[1].id];

export const CONFIGURATOR_THEME_CATEGORIES: ConfiguratorThemeCategory[] = [
  {
    id: 'design',
    name: {
      en: 'Design',
    },
    icon: '',
  },
  {
    id: 'colors',
    name: {
      en: 'Colors',
    },
    icon: '',
  },
  {
    id: 'art',
    name: {
      en: 'Art Style',
    },
    icon: '',
  },
];

export const CONFIGURATOR_PACKAGE_OFF_LEVEL: ConfiguratorEngagementPackageLevel = {
  id: false,
  name: {
    en: 'Off',
  },
  description: {
    en: '',
  },
  price: 0,
  currency: '',
  discount: 0,
  benefits: [],
};

export const CONFIGURATOR_PACKAGE_OFF_LEVEL_DETAILS: ConfiguratorContextEngagementPackageLevelDetails = {
  titleText: '',
  priceText: '',
  discountText: '',
  benefits: [],
  benefitsActive: false,
};

export const CONFIGURATOR_BREAKPOINTS: ConfiguratorBreakpoint[] = [
  {
    id: 'xs',
    name: {
      en: 'XS',
    },
    width: 360,
    height: 720,
    icon: 'bi-phone',
    className: 'breakpoint-xs',
  },
  {
    id: 'sm',
    name: {
      en: 'SM',
    },
    width: 576,
    height: 768,
    icon: 'bi-tablet',
    className: 'breakpoint-sm',
  },
  {
    id: 'md',
    name: {
      en: 'MD',
    },
    width: 768,
    height: 576,
    icon: 'bi-tablet-landscape',
    className: 'breakpoint-md',
  },
  {
    id: 'lg',
    name: {
      en: 'LG',
    },
    width: 992,
    height: 768,
    icon: 'bi-laptop',
    className: 'breakpoint-lg',
  },
  {
    id: 'xl',
    name: {
      en: 'XL',
    },
    width: 1200,
    height: 800,
    icon: 'bi-display',
    className: 'breakpoint-xl',
  },
  {
    id: 'xxl',
    name: {
      en: 'Full',
    },
    width: 1400,
    height: 900,
    icon: 'bi-tv',
    className: 'breakpoint-xxl',
  },
];

export const CONFIGURATOR_FULLSCREEN_BREAKPOINT = CONFIGURATOR_BREAKPOINTS[CONFIGURATOR_BREAKPOINTS.length - 1];

export const CONFIGURATOR_MOBILE_MEDIA_QUERY = '(max-width: 576px)';

export const CONFIGURATOR_PREVIEW_LOAD_BUFFER = 2 * 1000;
